import React from 'react'
import { Row, Paragraph, useContainerWidth } from '@fs/zion-ui'
import { ContentDownload } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { PillButton } from '../buttons'

type DownloadableResourceProps = {
  url?: string
  title?: string
}

const DownloadableResource = ({ url = '', title = 'Brochure' }: DownloadableResourceProps): JSX.Element => {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  return (
    <Row wrap guttersY="sm" alignX={atWidth({ default: 'center', md: 'start' })}>
      <PillButton to={url} linkName={`Download Resource: ${title}`} emphasis="medium" Icon={ContentDownload}>
        {t('download.label', 'Download')}
      </PillButton>
      <Paragraph size="sm" noGrowY centered={atWidth({ default: true, md: false })} alignY="middle">
        {title}
      </Paragraph>
    </Row>
  )
}

export default DownloadableResource
